import { render, staticRenderFns } from "./TelegramHistory.vue?vue&type=template&id=63c11e95&scoped=true&"
import script from "./TelegramHistory.vue?vue&type=script&lang=js&"
export * from "./TelegramHistory.vue?vue&type=script&lang=js&"
import style0 from "./TelegramHistory.vue?vue&type=style&index=0&id=63c11e95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c11e95",
  null
  
)

export default component.exports